import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=ad460d7e&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=ad460d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad460d7e",
  null
  
)

export default component.exports